/**
 * Troca obrigatória da senha provisória no primeiro login — Optimale Grid (frontend).
 *
 * Criado em: 02/11/2026 · Última modificação: 02/11/2026 · Versão: 1.0.0
 *
 * Com `usuario.trocar_senha`, o backend só aceita `eu`, `logout` e `POST /api/v1/auth/trocar-senha`; esta tela fica
 * no lugar de todas as outras até a troca. A sessão continua depois da troca (não precisa entrar de novo).
 */
import { useState, type FormEvent } from "react";
import { api, ErroApi, type Usuario } from "../api";
import { useSessao } from "../sessao";
import { TituloMarca } from "../marca";

export function TrocarSenha() {
  const { usuario, atualizarUsuario, sair } = useSessao();
  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [esperando, setEsperando] = useState(false);
  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    setErro(null);
    if (nova !== confirmacao) { setErro("A confirmação não é igual à nova senha."); return; }
    if (nova === atual) { setErro("A nova senha precisa ser diferente da provisória."); return; }
    setEsperando(true);
    try {
      atualizarUsuario(await api<Usuario>("/v1/auth/trocar-senha", { corpo: { senha_atual: atual, nova_senha: nova } }));
    } catch (falha) {
      setErro(falha instanceof ErroApi ? (falha.status === 403 ? "A senha provisória está incorreta." : falha.message)
        : "Backend indisponível.");
    } finally {
      setEsperando(false);
    }
  };
  return (
    <div className="nx-tela tela-login" data-tema="cco">
      <form className="nx-cartao cartao-login" onSubmit={enviar} aria-label="Trocar a senha provisória">
        <TituloMarca />
        <h2>Crie a sua senha</h2>
        <p className="nx-suave">Olá, {usuario?.nome}. Você entrou com uma senha provisória; troque-a para continuar.</p>
        <div className="nx-campo" data-obrigatorio>
          <label htmlFor="senha-atual">Senha provisória</label>
          <input id="senha-atual" type="password" autoComplete="current-password" value={atual}
            onChange={(e) => setAtual(e.target.value)} required />
        </div>
        <div className="nx-campo" data-obrigatorio>
          <label htmlFor="senha-nova">Nova senha</label>
          <input id="senha-nova" type="password" autoComplete="new-password" value={nova} aria-describedby="regra-senha"
            onChange={(e) => setNova(e.target.value)} required />
        </div>
        <p id="regra-senha" className="nx-suave">Mínimo de 12 caracteres, com letra maiúscula, letra minúscula e número, sem o seu login.</p>
        <div className="nx-campo" data-obrigatorio>
          <label htmlFor="senha-confirmacao">Repita a nova senha</label>
          <input id="senha-confirmacao" type="password" autoComplete="new-password" value={confirmacao}
            onChange={(e) => setConfirmacao(e.target.value)} required />
        </div>
        {erro && <p className="erro" role="alert">{erro}</p>}
        <button type="submit" className="nx-botao nx-botao-principal" disabled={esperando}>{esperando ? "Salvando…" : "Salvar a nova senha"}</button>
        <button type="button" className="link-esqueci" onClick={() => void sair()}>Sair</button>
      </form>
    </div>
  );
}
